import { Card } from 'primeng/card';
import { Router } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AuthService } from '../../../../core/services/auth.service';
import { SupportRequestFormComponent } from '../../../../shared/components/support-request-form/support-request-form.component';

@Component({
	selector: 'app-support-request-page',
	templateUrl: './support-request.page.html',
	imports: [Card, SupportRequestFormComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportRequestPageComponent {
	private readonly router = inject(Router);
	private readonly authService = inject(AuthService);

	/**
	 * Handles successful form submission - signs out and redirects to sign-in.
	 */
	public onFormSubmitted(): void {
		this.authService.signOut();
		this.router.navigateByUrl('/auth/sign-in', { replaceUrl: true }).then();
	}
}
